import { useTranslation } from 'react-i18next';

import { NgNotificationBadge, NgTab, NgTabPanel } from '@/ui';
import type { IncidentListRow } from '@/features/shared/incidentListRow';
import type { IncidentListContext } from './incidentListContext';
import type { CallWithIncidentId } from './incidentListSelectors';
import { CallNotificationList } from './CallNotificationList';
import { IncidentListPageList } from './IncidentListPageList';

export type IncidentListTabProps = {
  isLoading?: boolean;
  forwardedIncidents: readonly IncidentListRow[];
  currentlyOpenIncidents: readonly IncidentListRow[];
  recentClosedIncidents: readonly IncidentListRow[];
  callNotifications?: readonly CallWithIncidentId[];
  onTabSwitch?: (context: IncidentListContext) => void;
};

export function IncidentListTab({
  isLoading = true,
  forwardedIncidents,
  currentlyOpenIncidents,
  recentClosedIncidents,
  callNotifications,
  onTabSwitch,
}: IncidentListTabProps) {
  const { t } = useTranslation();

  const changeContext = (tabId: string) => {
    if (tabId === 'incidents') {
      onTabSwitch?.('incidents');
    } else if (tabId === 'call-notifications') {
      onTabSwitch?.('callNotifications');
    }
  };

  return (
    <NgTabPanel onTabChanged={changeContext}>
      <NgTab
        id="incidents"
        header={
          <>
            <span>{t('IncidentList_TabTitle')}</span>
            <NgNotificationBadge text={String(forwardedIncidents.length)} color="blue" />
            <NgNotificationBadge text={String(currentlyOpenIncidents.length)} color="orange" />
          </>
        }
        content={
          <IncidentListPageList
            forwardedIncidents={forwardedIncidents}
            currentlyOpenIncidents={currentlyOpenIncidents}
            recentClosedIncidents={recentClosedIncidents}
            isLoading={isLoading}
          />
        }
      />
      <NgTab
        id="call-notifications"
        header={
          <>
            <span>{t('CallNotification_IncomingCalls')}</span>
            <NgNotificationBadge text={callNotifications == null ? '' : String(callNotifications.length)} color="black" />
          </>
        }
        content={<CallNotificationList callNotifications={callNotifications} isLoading={isLoading} />}
      />
    </NgTabPanel>
  );
}
